import { createApiHandler } from './handler';

const branches = {
  apiClient: null,
  path: '/franchises/branches',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default branches;
